// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"f8d50e22","703":"4f724730","787":"3d7f0d1f"}[chunkId] + ".chunk.js";
};